import $ from 'jquery';
import 'jquery-countdown';
import template from '../html/template.hbs';
import BaseComponent from '../../../general/js/base-component';

export default class ActionCountdownComponent extends BaseComponent {
    constructor() {
        super(...arguments);

        let auctionDate = this.element.dataset.auctionDate;
        if(!auctionDate){
            throw new Error('auctionDate is required');
        }

        this.$element = $(this.element);
        this.auctionDate = new Date(auctionDate);
        this.init();
    }

    init() {
        //initial render
        let lastString = null;
        let initialItems = ['00', '00', '00'];
        this.render(this.getData(initialItems));

        let delimiter = ':';
        this.$element.countdown(this.auctionDate, (event) => {
            if (event.type === 'update') {
                let newDateString = event.strftime(`%D${delimiter}%H${delimiter}%M`);
                if (newDateString !== lastString) {
                    let items = newDateString.split(delimiter);
                    this.render(this.getData(items));
                    lastString = newDateString;
                }
            }
        });
    }

    render(data) {
        this.element.innerHTML = '';
        this.element.insertAdjacentHTML('afterBegin', template(data));
    }

    getData(items) {
        let labels = ['days', 'hours', 'minutes'];
        let resultItems = items.map((value, i) => {
            return {
                digits: value.split(''),
                label: labels[i]
            }
        });
        return {
            items: resultItems
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/next-auction-panel/js/action-countdown.component.js